<div [class]="'mat-alert mat-alert-' + type" role="alert">
    <ng-container *ngIf="dismissible">
    </ng-container>
    <ng-content></ng-content>

    <div class="powered-by-container">
        <powered-by />
      </div> 
</div>